export default {"src":"/_next/static/media/lightBulb_24.3cce6a57.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};